module.exports = __webpack_public_path__ + "assets/img/Future_006.135bcd3a-ps.jpg";